import { React, useEffect, useState } from "react";
import { ModalPopup } from "./modal";
import Iconmoon from "../IconsFiles/icon";
import warning from "../../Assets/Icons/warning.png";
import {
  Button,
  Form,
  Input,
  Select,
  Col,
  Row,
  Checkbox,
  Radio,
  AutoComplete,
  Tooltip,
  Dropdown,
  Menu,
} from "antd";
import { getUnitData } from "../../Services/measurementService";
import { getReelCoreValues } from "../../Services/settingsServices";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
  DropDownSearchDraw,
} from "../../Pages/styledElements";
import { lengthUnit, 
  weightUnit,
  weight_Unit_Conversions,
  orderDim_Rewinder_Unit_Conversion,
  currency_List,
  conversionFactorTonneToUnits,
  CoversionFactorCMToUnits, } from "../../Utils/Constant/MeasurementUnitList";
import {
  PaperMachineQualitySelect,
  PaperMachineGradeSelect,
} from "../../Pages/pageStyled";
import Multiselect from "multiselect-react-dropdown";
import styled from "styled-components";

const rewinderType = [
  { label: "Constant", value: "constant" },
  { label: "Range", value: "range" },
];
const { Option } = Select;

const multiselectStyle = {
  chips: {},
  searchBox: {
    border: "2px solid #dfe1e6",
    "border-radius": "8px",
    "background-color": "var(--form-element-bg)",
  },
  option: {
    // To change css for dropdown options
    //background : "gray"
  },
};

const MultiSelectCard = styled.div`
  .optionContainer li:hover,
  .optionContainer .highlight {
    background: #edebe9;
    color: black;
  }
  .multiSelectContainer input[type="text"] {
    padding-left: 15px !important;
    width: 100%;
  }
  .optionContainer .highlight {
    background: white;
    color: black;
  }
  .optionListContainer {
    z-index: 100;
  }
  li.groupHeading {
    color: black;
    padding: 5px 15px;
    pointer-events: none;
    font-weight: 500;
  }
  .multiSelectContainer ul {
    border-radius: 0px;
    margin-top: 4px;
  }
  .multiSelectContainer input[type="checkbox"] {
    accent-color: rgb(234, 101, 91);
  }
  .ant-btn {
    border: 0px solid transparent !important;
  }
`;

const ReelCoreEditModal = ({
  visible,
  icon,
  param,
  confirmAction,
  cancelAction,
  children,
  orderData,
  type,
}) => {
  const [form] = Form.useForm();

  const [measurementData, setMeasurementData] = useState();
  const [reelCoreData, setReelCoreData] = useState();
  const [reelValues, setReelvalues] = useState();
  const [coreValues, setCoreValues] = useState();
  const [selectedReelOD, setSelectedReelOD] = useState();
  const [reelODValidationError, setReelODValidationError] = useState(false);
  const [coreOdValidationError, setCoreOdValidationError] = useState(false);
  const [outerDiameter, setOuterDiameter] = useState(orderData.id_od_type);
  const [selectedType, setSelectedType] = useState(orderData?.type?.toLowerCase());
  const [orderQuantity, setOrderQuantity] = useState(orderData.quantity_type);
  const [coreOD, setCoreod] = useState("");
  const [reelOD, setReelod] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const response = await getReelCoreValues();
        if (!response.error) {
          setReelCoreData(response);
          const reelData = response.reel_data.map((item) => {
            return {
              value: item[0] + " " + item[1],
            };
          });
          const coreData = response.core_data.map((item) => {
            return {
              value: item[0] + " " + item[1],
            };
          });
          setCoreValues(coreData);
          setReelvalues(reelData);
          if (
            orderData?.type.toLowerCase() == "reel" &&
            orderData?.quantity_type == "reel_sheet"
          ) {
            setReelod(orderData?.outer_dia[0]);
            form.setFieldsValue({ reel_OD: orderData?.outer_dia[0] });
          } else {
            let outerDiaArr = [];
            for (let i = 0; i < orderData?.outer_dia.length; i++) {
              let outerDiaObj = {};
              outerDiaObj["value"] = orderData?.outer_dia[i];
              outerDiaArr.push(outerDiaObj);
            }
            setSelectedReelOD(outerDiaArr);
          }
          setCoreod(orderData?.inner_dia);
          form.setFieldsValue({ core_OD: orderData?.inner_dia });
        }
      } catch (error) {
        console.log(error);
      }

      try {
        const unitData = await getUnitData();
        if (!unitData.error) {
          setMeasurementData(unitData);
        }
      } catch (err) {
        console.log(err);
      }

      // try {
      //   const response = await getReelCoreValues();
      //   if (!response.error) {
      //     setReelCoreData(response);
      //     const reelData = response.reel_data.map((item) => {
      //       return {
      //         value: item[0] + " " + item[1],
      //       };
      //     });
      //     const coreData = response.core_data.map((item) => {
      //       return {
      //         value: item[0] + " " + item[1],
      //       };
      //     });
      //     setCoreValues(coreData);
      //     setReelvalues(reelData);
      //   }
      // } catch (error) {
      //   console.log(error);
      // }
      //   let orderMangtSettings = await getWorkflowSettings("order_management");
      //   setOrderMangtSettings(orderMangtSettings);
    })();
  }, []);

  const handleRewinderType = (e) => {
    setOuterDiameter(e.target.value);
    // setPlannedReels(0);
    // setPlannedWeight(0);
    // form.setFieldsValue({no_of_reel_sheet : 0});
    // form.setFieldsValue({planned_weight: 0});
    setSelectedReelOD([]);
    setCoreOdValidationError(false);
    setReelODValidationError(false);
    form.resetFields();
    form.setFieldsValue({ reel_OD:'',
    min_reel_od:'',
    max_reel_od : ''

  })
    form.setFieldsValue({reelOD_unit: measurementData?.data?.units_management?.length.default});
  };

  const handleCoreOD = (e) => {
    setCoreod(e);
    if (orderQuantity == "reel_sheet" && selectedType == "reel") {
      let coreodConversion = orderDim_Rewinder_Unit_Conversion[e?.split(" ")[1]];
      let reelodConversion = orderDim_Rewinder_Unit_Conversion[reelOD?.split(" ")[1]];
      let coreODValue =  (e?.split(" ")[0] * coreodConversion);
      let reelOdValue =  (reelOD?.split(" ")[0] * reelodConversion);
      if (
        reelOD &&
        parseFloat(coreODValue) > parseFloat(reelOdValue)
      ) {
        setCoreOdValidationError(true);
      } else {
        setCoreOdValidationError(false);
      }
    } else {
      let coreodConversion = orderDim_Rewinder_Unit_Conversion[e?.split(" ")[1]];
      //let reelodConversion = orderDim_Rewinder_Unit_Conversion[selectedReelOD[0]?.value?.split(" ")[1]];
      let minReelOD ;

      if(outerDiameter == 'constant')
      {
      let reelData = selectedReelOD?.map((data) => {
        return data.value?.split(" ")[0] *  orderDim_Rewinder_Unit_Conversion[data?.value?.split(" ")[1]];
      })
      minReelOD = Math.min(...reelData);
    }
    else
    {
      minReelOD = orderDim_Rewinder_Unit_Conversion[orderData.units?.minimum_reel_od] * orderData.minimum_reel_od;

    }

      
      let coreODValue =  (e?.split(" ")[0] * coreodConversion);
      //let reelOdValue =  (selectedReelOD[0]?.value?.split(" ")[0] * reelodConversion);
      //if(selectedReelOD?.length == 1 && outerDiameter == 'constant' ){
        if (parseFloat(coreODValue) > (parseFloat(minReelOD))) {
          setCoreOdValidationError(true);
        } else {
          setCoreOdValidationError(false);
        }
      // } else{
      //   setCoreOdValidationError(false);
      // }
    }
  };

  const onChangeReelOdSelect = (data) => {
    setSelectedReelOD(data);
    let minReelOD ;
      let reelData = data?.map((item) => {
        return item.value?.split(" ")[0] *  orderDim_Rewinder_Unit_Conversion[item?.value?.split(" ")[1]];
      })
      minReelOD = Math.min(...reelData);
   // if (data?.length == 1) {
      let coreodConversion = orderDim_Rewinder_Unit_Conversion[coreOD?.split(" ")[1]];
      let reelodConversion = orderDim_Rewinder_Unit_Conversion[data[0]?.value?.split(" ")[1]];
      let coreODValue =  (coreOD?.split(" ")[0] * coreodConversion);
      let reelOdValue =  (data[0]?.value?.split(" ")[0] * reelodConversion);
      if ((coreOD && parseFloat(coreODValue)) > parseFloat(minReelOD)) {
        setCoreOdValidationError(true);
      } else {
        setCoreOdValidationError(false);
      }
   // }
  };

  const removeReelOD = (data) => {
    let array = selectedReelOD;
    let newArray = array.filter((item) => {
      return !(item.value === data.value);
    });

    let minReelOD ;
      let reelData = newArray?.map((item) => {
        return item.value?.split(" ")[0] *  orderDim_Rewinder_Unit_Conversion[item?.value?.split(" ")[1]];
      })
      minReelOD = Math.min(...reelData);
    //if (newArray?.length == 1) {
      let coreodConversion = orderDim_Rewinder_Unit_Conversion[coreOD?.split(" ")[1]];
      let reelodConversion = orderDim_Rewinder_Unit_Conversion[newArray[0]?.value?.split(" ")[1]];
      let coreODValue =  (coreOD?.split(" ")[0] * coreodConversion);
      let reelOdValue =  (newArray[0]?.value?.split(" ")[0] * reelodConversion);
      if ((coreOD && parseFloat(coreODValue)) > parseFloat(minReelOD)) {
        setCoreOdValidationError(true);
      } else {
        setCoreOdValidationError(false);
      }
   // }
    setSelectedReelOD(newArray);
  };

  const handleReelOD = (e) => {
    //setReelod(e);
    let coreodConversion = orderDim_Rewinder_Unit_Conversion[coreOD?.split(" ")[1]];
    let reelodConversion = orderDim_Rewinder_Unit_Conversion[e?.split(" ")[1]];
    let coreODValue =  (coreOD?.split(" ")[0] * coreodConversion);
    let reelOdValue =  (e?.split(" ")[0] * reelodConversion);
    if ((coreOD && parseFloat(coreODValue)) > parseFloat(reelOdValue)) {
      setCoreOdValidationError(true);
    } else {
      setCoreOdValidationError(false);
    }
  };

  const onMinReelODChange = (e) => {
    if (
      parseFloat(e.target.value) > parseFloat(form.getFieldValue("max_reel_od"))
    ) {
      setReelODValidationError(true);
    } else {
      let minReelOD;

      minReelOD =
        orderDim_Rewinder_Unit_Conversion[form.getFieldValue("reelOD_unit")] *
        e.target.value;
        let coreodConversion = orderDim_Rewinder_Unit_Conversion[coreOD?.split(" ")[1]];
      let coreODValue = coreOD?.split(" ")[0] * coreodConversion;
      if ((coreOD && parseFloat(coreODValue)) > parseFloat(minReelOD)) {
       
          setCoreOdValidationError(true);
        } else {
          setCoreOdValidationError(false);
        }
      
      setReelODValidationError(false);
    }
  };

  const onMaxReelODChange = (e) => {
    if (
      parseFloat(e.target.value) < parseFloat(form.getFieldValue("min_reel_od"))
    ) {
      setReelODValidationError(true);
    } else {
      setReelODValidationError(false);
    }
  };

  const handleReelUnitChange = (e) => {
    let minReelOD;

      minReelOD =
        orderDim_Rewinder_Unit_Conversion[e] *
       parseFloat( form.getFieldValue('min_reel_od'));
        let coreodConversion = orderDim_Rewinder_Unit_Conversion[coreOD?.split(" ")[1]];
      let coreODValue = parseFloat( coreOD?.split(" ")[0]) * coreodConversion;
      if ((coreOD && parseFloat(coreODValue)) > parseFloat(minReelOD)) {
          setCoreOdValidationError(true);
          setReelODValidationError(false);
        } else {
          setCoreOdValidationError(false);
          setReelODValidationError(false)
        }
  }

  const saveData = () => {
    if(!reelODValidationError && !coreOdValidationError)
    form.submit();
  };

  const onFinish = (event) => {

    let data;
    if (type == "reel") {
      let reelODArr = [];
      selectedReelOD?.map((item) => {
        reelODArr.push(item.value);
      });
      data = {
        ...(outerDiameter == "constant" && {
          outer_dia:
            selectedType == "reel" && orderQuantity === "reel_sheet"
              ? [event.reel_OD]
              : reelODArr,
        }),
        ...(outerDiameter == "range" && {
          minimum_reel_od: event.min_reel_od
            ? parseFloat(event.min_reel_od)
            : "",
        }),
        ...(outerDiameter == "range" && {
          maximum_reel_od: event.max_reel_od
            ? parseFloat(event.max_reel_od)
            : "",
        }),
        type: "reel",
        orderData: orderData,
        units: {
          ...(outerDiameter == "range" && {
            minimum_reel_od: event.reelOD_unit,
          }),
          ...(outerDiameter == "range" && {
            maximum_reel_od: event.reelOD_unit,
          }),
         
        },
        orderData: orderData,
        reel_type : outerDiameter
      };
    } else {
      data = {
        inner_dia: event.core_OD,
        type: "core",
        orderData: orderData,
      };
    }

    if(type == 'reel')
    {
    if(outerDiameter == "constant")
    {
      if(selectedReelOD.length)
      {
     confirmAction(data);

      }
    }
    else
    {
    confirmAction(data);
    }
  }

  else{
    if(coreOD)
    {
      confirmAction(data);
    }
  }

  };

  return (reelCoreData && reelValues && coreValues) ?  (
    <ModalPopup visible={visible} style = {{width: '335px'}}>
      <>
        <div className="resetPassForm removePadLeft">
          <DetailFields
            className="marginBtnP"
            style={{ paddingBottom: "15px" }}
          >
            <HaberForm>
              <Form
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "0" }}
                onFinish={onFinish}
                form={form}
              >
                <div
                  className="drawerField"
                  style={{
                    borderBottom: "0px solid #edebe9",
                  }}
                >
                  {type === "core" && (
                    <>
                      <div className="titleWithText">
                        <p style={{ marginLeft: "3px", marginBottom: "4px" }}>
                          Core OD
                        </p>
                      </div>
                      <Form.Item
                        name="core_OD"
                        rules={[]}
                        className="selectForm"
                      >
                        <Select
                          placeholder="Select Core OD"
                          suffixIcon={<DownArrowDraw />}
                          showSearch
                          optionFilterProp="children"
                          onChange={handleCoreOD}
                          //   disabled={
                          //     (props.isEditFromIncompleteOrder &&
                          //       props.type === "deckleRecord") ||
                          //     (props.isEditFromIncompleteOrder &&
                          //       props.type === "orderRecord" &&
                          //       !orderMangtSettings?.data?.edit_after_approval
                          //         ?.value) ||
                          //     props?.actionType == "view"
                          //   }
                        >
                          {coreValues?.map((data) => (
                            <Option key={data.value}>{data.value}</Option>
                          ))}
                        </Select>
                      </Form.Item>
                      { coreOdValidationError ? (
                        <div
                          className="errorText"
                          style={{
                            color: "#ea4e2c",
                            marginLeft: "2px",
                           
                            marginBottom: "20px",
                          }}
                        >
                          Reel OD cannot be less than Core OD
                        </div>
                      ) : null}
                    </>
                  )}
                  {type === "reel" && (
                    <>
                      <div
                        className=" switchRadio twoSwitch"
                        style={{
                          justifyContent: "center",
                          display: "flex",
                        }}
                      >
                        <Radio.Group
                          options={rewinderType}
                          optionType="button"
                          buttonStyle="solid"
                          value={outerDiameter}
                            disabled={
                              (selectedType == "reel" && orderQuantity == "reel_sheet") 
                              // ||(props.isEditFromIncompleteOrder &&
                              //   props.type === "deckleRecord") ||
                              // (props.isEditFromIncompleteOrder &&
                              //   props.type === "orderRecord" &&
                              //   !orderMangtSettings?.data?.edit_after_approval
                              //     ?.value) ||
                              // props?.actionType == "view"
                            }
                          onChange={handleRewinderType}
                        />
                      </div>
                      {outerDiameter === "constant" ? (
                        selectedType == "reel" && orderQuantity == "reel_sheet" ? (
                          <div className="titleWithText">
                            <p
                              style={{
                                marginLeft: "3px",
                                marginBottom: "4px",
                                marginTop: "22px",
                              }}
                            >
                              Reel OD
                            </p>
                            <Form.Item
                              name="reel_OD"
                              rules={[]}
                              className="selectForm"
                            >
                              <Select
                                placeholder="Select Reel OD"
                                suffixIcon={<DownArrowDraw />}
                                showSearch
                                optionFilterProp="children"
                                onChange={handleReelOD}
                                // disabled={
                                //   (props.isEditFromIncompleteOrder &&
                                //     props.type === "deckleRecord") ||
                                //   (props.isEditFromIncompleteOrder &&
                                //     props.type === "orderRecord" &&
                                //     !orderMangtSettings?.data?.edit_after_approval
                                //       ?.value) ||
                                //   props?.actionType == "view"
                                // }
                              >
                                {reelValues?.map((data) => (
                                  <Option key={data.value}>{data.value}</Option>
                                ))}
                              </Select>
                            </Form.Item>
                            {coreOdValidationError ? (
                        <div
                          className="errorText"
                          style={{
                            color: "#ea4e2c",
                            marginLeft: "2px",
                           
                            marginBottom: "20px",
                          }}
                        >
                          Reel OD cannot be less than Core OD
                        </div>
                      ) : null}
                          </div>
                        ) : (
                          <div>
                            <p
                              style={{
                                marginLeft: "3px",
                                marginBottom: "4px",
                                marginTop: "15px",
                              }}
                            >
                              Reel OD
                            </p>
                            <Col className="blockBreak">
                              <div className="boxFormType">
                                <PaperMachineQualitySelect>
                                  <MultiSelectCard>
                                    <Multiselect
                                      className="multiQuality"
                                      options={reelValues}
                                      style={multiselectStyle}
                                      showArrow={true}
                                      selectedValues={selectedReelOD}
                                      displayValue={"value"}
                                      showCheckbox={true}
                                      //   disable={
                                      //     (props.isEditFromIncompleteOrder &&
                                      //       props.type === "deckleRecord") ||
                                      //     (props.isEditFromIncompleteOrder &&
                                      //       props.type === "orderRecord" &&
                                      //       !orderMangtSettings?.data
                                      //         ?.edit_after_approval?.value) ||
                                      //     props?.actionType == "view"
                                      //   }
                                      onSelect={onChangeReelOdSelect}
                                      onRemove={onChangeReelOdSelect}
                                      hideSelectedList
                                      keepSearchTerm
                                    />
                                  </MultiSelectCard>
                                </PaperMachineQualitySelect>
                               
                              </div>
                                <PaperMachineGradeSelect>
                                  <div className="mainMachineGrade">
                                    {selectedReelOD &&
                                      selectedReelOD?.map((item, index) => {
                                        return (
                                          index < 2 && (
                                            <span
                                              className={
                                                "MachineGradeSelect-active"
                                              }
                                            >
                                              {item.value}
                                              <Button
                                                style={{
                                                  border:
                                                    "0px solid transparent",
                                                    margin : '0px !important',
                                                    background : '#fdf0ef'
                                                }}
                                                className=" textBtnIcon paperButtonBg"
                                                onClick={() => {
                                                  removeReelOD(item);
                                                }}
                                                // disabled={
                                                //   props?.actionType == "view" ||
                                                //   (props.isEditFromIncompleteOrder &&
                                                //     props.type ===
                                                //       "deckleRecord") ||
                                                //   (props.isEditFromIncompleteOrder &&
                                                //     props.type === "orderRecord" &&
                                                //     !orderMangtSettings?.data
                                                //       ?.edit_after_approval
                                                //       ?.value) ||
                                                //   props?.actionType == "view"
                                                // }
                                              >
                                                <Iconmoon
                                                  icon="wrong"
                                                  size={14}
                                                  color="#EA655B"
                                                />
                                              </Button>
                                            </span>
                                          )
                                        );
                                      })}
                                  </div>
                                  {selectedReelOD &&
                                    selectedReelOD?.length >= 2 &&
                                    selectedReelOD?.map((item, index) => {
                                      let tooltipData = "";
                                      for (
                                        let index = 2;
                                        index < selectedReelOD?.length;
                                        index++
                                      ) {
                                        const data = selectedReelOD[index];
                                        tooltipData =
                                          tooltipData + data.value + ", ";
                                      }
                                      tooltipData = tooltipData.substring(
                                        0,
                                        tooltipData.length - 1
                                      );
                                      return (
                                        index == 2 && (
                                          <Tooltip title={tooltipData}>
                                            {" "}
                                            <span
                                              style={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                              }}
                                            >
                                              & {selectedReelOD.length - 2} More
                                            </span>
                                          </Tooltip>
                                        )
                                      );
                                    })}
                                </PaperMachineGradeSelect>
                            </Col>
                            { coreOdValidationError ? (
                        <div
                          className="errorText"
                          style={{
                            color: "#ea4e2c",
                            marginLeft: "2px",
                            marginBottom: "20px",
                          }}
                        >
                          Reel OD cannot be less than Core OD
                        </div>
                      ) : null}
                          </div>
                        )
                      ) : (
                        <div style={{ marginTop: "20px" }}>
                          <Col span={24}>
                            <Row className="centerAlign justifyCSBetween">
                              <Col
                                span={9}
                                className="blockBreak"
                                style={{ paddingRight: "5px" }}
                              >
                                <div
                                  className="boxFormType"
                                  style={{ marginBottom: "0" }}
                                >
                                  <Form.Item
                                    label="Min Reel OD"
                                    name="min_reel_od"
                                    rules={[
                                      {
                                        required: true,
                                        message: "Min Reel OD is required",
                                      },
                                      {
                                        pattern: new RegExp(
                                          /^\d+(\.\d{0,3})?$/
                                        ),
                                        message:
                                          "Only Numeric value is possible upto 3 decimal point",
                                      },
                                      {
                                        pattern: new RegExp(
                                        /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                        ),
                                        message:
                                        "Value should be a number greater than zero",
                                      },
                                    ]}
                                    className="dBlock"
                                    initialValue={orderData?.minimum_reel_od}
                                  >
                                    <Input
                                      placeholder="Min Reel OD"
                                      className={
                                        reelODValidationError
                                          ? "showErrorBorder"
                                          : ""
                                      }
                                      onChange={(e) => {
                                        onMinReelODChange(e);
                                      }}
                                    />
                                  </Form.Item>
                                </div>
                              </Col>
                              <Col
                                span={9}
                                className="blockBreak"
                                style={{ paddingRight: "5px" }}
                              >
                                <div
                                  className="boxFormType"
                                  style={{ marginBottom: "0" }}
                                >
                                  <Form.Item
                                    label="Max Reel OD"
                                    name="max_reel_od"
                                    rules={[
                                      {
                                        required: true,
                                        message: "Max Reel OD is required",
                                      },
                                      {
                                        pattern: new RegExp(
                                          /^\d+(\.\d{0,3})?$/
                                        ),
                                        message:
                                          "Only Numeric value is possible upto 3 decimal point",
                                      },
                                      {
                                        pattern: new RegExp(
                                        /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                        ),
                                        message:
                                        "Value should be a number greater than zero",
                                      },
                                    ]}
                                    className="dBlock"
                                    initialValue={orderData?.maximum_reel_od}
                                  >
                                    <Input
                                      placeholder="Max Reel OD"
                                      className={
                                        reelODValidationError
                                          ? "showErrorBorder"
                                          : ""
                                      }
                                      onChange={(e) => {
                                        onMaxReelODChange(e);
                                      }}
                                    />
                                  </Form.Item>
                                </div>
                              </Col>
                              <Col span={6} className="blockBreak">
                                <div className="boxFormType unitSelect">
                                  <Form.Item
                                    label="Unit"
                                    name="reelOD_unit"
                                    rules={[]}
                                    className="dBlock"
                                    initialValue={orderData?.units?.minimum_reel_od}
                                  >
                                    <Select
                                      placeholder="Unit"
                                      suffixIcon={<DownArrowDraw />}
                                      className="dBlock"
                                      onChange={handleReelUnitChange}
                                    >
                                      {measurementData?.data.units_management.length.data?.map(
                                        (reelUnit) => (
                                          <Option
                                            key={reelUnit}
                                            value={reelUnit}
                                          >
                                            {lengthUnit[reelUnit]?.displayName}
                                          </Option>
                                        )
                                      )}
                                    </Select>
                                  </Form.Item>
                                </div>
                              </Col>
                              {reelODValidationError ? (
                                <span
                                  className="errorText"
                                  style={{
                                    color: "#ea4e2c",
                                    marginTop: "-2px",
                                  }}
                                >
                                  Max dia cannot be less than Min dia
                                </span>
                              ) : null}
                               { coreOdValidationError ? (
                        <div
                          className="errorText"
                          style={{
                            color: "#ea4e2c",
                            marginLeft: "2px",
                            marginBottom: "20px",
                          }}
                        >
                          Reel OD cannot be less than Core OD
                        </div>
                      ) : null}
                            </Row>
                          </Col>
                        </div>
                      )}
                    </>
                  )}
                  {/* {((selectedReelOD && selectedReelOD?.length == 1) ||
                    (reelOD &&
                      orderQuantity == "reel" &&
                      selectedType == "reel")) &&
                  outerDiameter !== "range" ? (
                    <div>
                      <div className="titleWithText">
                        <h5
                          style={{
                            color: "#ea655b",
                            marginTop: "10px",
                          }}
                        >
                          Calculated number of reels on specified Core{" "}
                        </h5>
                        <h5
                          style={{
                            color: "#ea655b",
                            marginTop: "5px",
                          }}
                        >
                          OD & Reel OD: {plannedReels}
                        </h5>
                      </div>
                      <Row className="centerAlign justifyCSBetween">
                        <Col span={10}>
                          <div className="boxFormType">
                            <p
                              style={{
                                marginBottom: "3px",
                                marginTop: "12px",
                              }}
                            >
                              Rewinder Reels
                            </p>
                            <Form.Item
                              name="no_of_reel_sheet"
                              rules={[
                                {
                                  pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                  message:
                                    "Only numeric characters upto 3 decimal points are allowed",
                                },
                              ]}
                              className="dBlock"
                            >
                              <Input
                                placeholder="Enter the number of reels"
                                onChange={(e) => {
                                  onPlannedReelsChange(e);
                                }}
                                disabled={
                                  (props.isEditFromIncompleteOrder &&
                                    props.type === "deckleRecord") ||
                                  (props.isEditFromIncompleteOrder &&
                                    props.type === "orderRecord" &&
                                    !orderMangtSettings?.data
                                      ?.edit_after_approval?.value) ||
                                  props?.actionType == "view"
                                }
                              />
                            </Form.Item>
                          </div>
                        </Col>
                        <Col span={13}>
                          <div className="boxFormType">
                            <p
                              style={{
                                marginBottom: "3px",
                                marginTop: "12px",
                              }}
                            >
                              Planned Weight
                            </p>
                            <Form.Item
                              name="planned_weight"
                              rules={[]}
                              className=""
                            >
                              <Input style={{ width: "185px" }} disabled />
                            </Form.Item>
                            <div
                              style={{
                                marginTop: "-57px",
                                marginLeft: "165px",
                                position: "relative",
                                fontFamily: "var(--sf-pro-text)",
                                color: "#a19f9d",
                              }}
                            >
                              {weightUnit[unitPlaceholder]?.displayName}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : null} */}
                </div>
              </Form>
            </HaberForm>
          </DetailFields>
        </div>
        <div className="ant-modal-footer-section">
         <Button key="submit" className="themeBtn" onClick={saveData}>
            <Iconmoon icon="edit" size={14} color="#ffff" />
            Save
          </Button>
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => cancelAction()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>
          
        </div>
      </>
    </ModalPopup>
  ) : null;
};

export default ReelCoreEditModal;
